import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Ocurrió un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function wsUrl(path) {
  const proto = BACKEND.startsWith("https") ? "wss" : "ws";
  const host = BACKEND.replace(/^https?:\/\//, "");
  return `${proto}://${host}${path}`;
}

export function imgUrl(u) {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND}${u}`;
}
